var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdsIconMandibleShift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.23094 5.55977C4.82586 5.42001 4.55436 5.03795 4.55576 4.60965L4.56428 2.00494C4.56609 1.45266 5.01526 1.00711 5.56754 1.00978L25.2588 1.10511C25.8111 1.10778 26.2573 1.55766 26.2555 2.10994L26.2251 11.4055C26.2229 12.0905 25.5482 12.5694 24.9003 12.3459L5.23094 5.55977Z",
    className: "wasm-icon-stroke",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0311 15.9071C22.4362 16.0469 22.7077 16.429 22.7063 16.8573L22.6978 19.462C22.696 20.0143 22.2468 20.4598 21.6945 20.4571L2.00329 20.3618C1.45101 20.3591 1.00476 19.9092 1.00657 19.357L1.03698 10.0615C1.03922 9.37646 1.71393 8.89751 2.36178 9.12102L22.0311 15.9071Z",
    className: "wasm-icon-stroke",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 22,
    className: "wasm-icon-fill"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdsIconMandibleShift);
export default __webpack_public_path__ + "static/media/SDS_icon_MandibleShift.6d2d87ad7a48c06318e9eb2d07ed142b.svg";
export { ForwardRef as ReactComponent };